function StepperProgressBarMobileNextLine() {
    return <svg width="75" height="113" viewBox="0 0 75 113" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M66.3789 1L66.3789 48.5" stroke="#AAAAAA" strokeWidth="1.5" strokeLinecap="round" strokeDasharray="4 4"/>
    <path d="M60.3789 54.5L66.2122 59.1667L72.0456 54.5" stroke="#AAAAAA" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M66.3789 64.5L66.3789 112" stroke="#AAAAAA" strokeWidth="1.5" strokeLinecap="round" strokeDasharray="4 4"/>
    <path d="M0.857422 1L30.9879 1" stroke="#AAAAAA" strokeWidth="1.5" strokeLinecap="round" strokeDasharray="4 4"/>
    <path d="M30.9883 1L61.1187 1" stroke="#AAAAAA" strokeWidth="1.5" strokeLinecap="round" strokeDasharray="4 4"/>
    <path d="M0.857422 112L30.9879 112" stroke="#AAAAAA" strokeWidth="1.5" strokeLinecap="round" strokeDasharray="4 4"/>
    <path d="M30.9883 112L61.1187 112" stroke="#AAAAAA" strokeWidth="1.5" strokeLinecap="round" strokeDasharray="4 4"/>
  </svg>;
}

export default StepperProgressBarMobileNextLine;